import { ngFrameworkLoaded } from "../ng/ng-integration";

export const useKeepAlive = () => {
    let lastKeepAlive = Date.now();

    const handler = async () => {
        if (Date.now() - lastKeepAlive < 30_000) return;
        await ngFrameworkLoaded();
        ng_fw.keepAlive();
        lastKeepAlive = Date.now();
    };

    document.addEventListener("click", handler, { passive: true });
    document.addEventListener("keypress", handler, { passive: true });
};
